module.exports = __webpack_public_path__ + "static/media/bg-spin.62bfd8b4.png";